/* eslint-disable camelcase */
import * as addActivity from '../services/addActivity';

export default {
  namespace: 'addActivity',

  state: {
    defaultValues: {
      title: '', //活动名称
      dateBeginTimestamp: null, //活动开始日期
      dateEndTimestamp: null, //活动结束日期
      luckyType: 1, // 活动玩法
      description: '', //活动详情
      isMember: '0', // 是否会员限制 0-不限 1-仅会员
      isMemberNumShow: '0', //参数人数展示 0-隐藏 1-展示
      isMemberNumLimit: '1', //参与人数限制radius 1不限制  0 限制
      memberNumLimit: '', //参与人数限制
      isAllCompany: '0', // 0全部公司true 1指定公司false
      isAllStore: '0', // 0全部门店true 1指定门店false
      stores: [], //可用门店列表
      useStory: false,
      isRotation: '1', //轮播开启 0-关闭 1-开启
      isPurchase: false, //单次购买x元商品可获得x次抽奖 0-不生效 1-生效
      content: '', //活动及兑换说明
      phone: '', //客服电话
      prizesList: [], //奖品信息
      companies: [],
      backgroundPic: '', //背景图片
      wheelPic: '', //转盘图片
      wheelBackgroundPic: '', //转盘背景图片
      prizeFontSize: 14,
      prizeFontColor: '#83C5AA',
      activityFontSize: 14,
      activityFontColor: '#83C5AA',
      drawNumSize: 16,
      drawNumColor: '#83C5AA',
      rotationFontSize: 18,
      fontColorType3: '#83C5AA',
      miniprogramNotice: 1,
      mChecked: false,
      mType: '', //渠道类型
      mContent: '',
      wChecked: false,
      wType: 0,
      wContent: '',
      noticeType: 'NOTICE_ONE', // 通知规则 NOTICE_ONE-仅通知一个渠道 NOTICE_ALL-全渠道通知
    },
  },

  effects: {
    //公司查询
    *getCompany({ payload: { value } }, { put, call }) {
      const response = yield call(addActivity.getCompany, value);
      let cList = [];
      if (response.data.length > 0) {
        cList = response.data.reduce(function (prev, cur) {
          return [...prev, ...cur.subCompany];
        }, []);
      }
      yield put({
        type: 'save',
        payload: {
          companyList: cList,
        },
      });
    },
    //门店查询
    *getStores({ payload: { value } }, { put, call }) {
      const response = yield call(addActivity.getStores, value);
      yield put({
        type: 'save',
        payload: {
          storesList: response.data.data,
          storesTotal: response.data.total,
        },
      });
    },
    //记录门店搜索
    *searchStores({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          storeName: value.storeName,
        },
      });
    },
    //记录门店的分页
    *setStoresPage({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          storesPageNum: value.pageNum,
          storesPageSize: value.pageSize,
        },
      });
    },
    //会员等级
    *getQueryLevels({ payload: { value }, callback }, { call, put }) {
      const response = yield call(addActivity.getQueryLevels, value);
      const list = response.data.map((item) => ({
        level: item.code,
        probability: '',
        name: item.name,
      }));
      yield put({
        type: 'save',
        payload: {
          queryLevelsList: list,
        },
      });
      response.data && callback && callback(response.data);
    },
    //分页查询礼品管理列表
    *getGiftQueryPage({ payload: { value }, callBack }, { put, call }) {
      const response = yield call(addActivity.getGiftQueryPage, value);
      yield put({
        type: 'save',
        payload: {
          giftList: response.data.data,
          giftTotal: response.data.total,
        },
      });
      callBack && callBack();
    },
    *resetForm({ payload: { value }, callback }, { put, select }) {
      yield put({
        type: 'save',
        payload: {
          defaultValues: value.defaultValues,
        },
      });
      const newV = yield select((state) => state.addActivity.stepOneData);
      callback && callback(newV);
    },
    *postFormData({ payload: { value }, callback }, { call }) {
      // eslint-disable-next-line no-unused-vars
      const response = yield call(addActivity.postFormData, value);
      response.code === 0 && callback && callback();
    },
    *postFormDataUpdate({ payload: { value }, callback }, { call }) {
      // eslint-disable-next-line no-unused-vars
      const response = yield call(addActivity.postFormDataUpdate, value);
      response.code === 0 && callback && callback();
    },
    *postFormDetail({ payload: { values }, callback }, { call }) {
      const response = yield call(addActivity.postFormDetail, values);

      callback && callback(response.data);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {},
};
